exports.f = Object.getOwnPropertySymbols;



/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/~/core-js/library/modules/_object-gops.js
 ** module id = 137
 ** module chunks = 0
 **/